import { twMerge } from "tailwind-merge";

import { keyStore } from "@/components/pitchCorrection/PitchCorrection";
import { handleKnobPitchChangeInternal } from "@/components/pitchCorrection/pitchKnob/handleKnobPitchChangeInternal";
import { pitchDiffsFromSemitoneData } from "@/components/pitchCorrection/pitchKnob/pitchDiffsFromSemitoneData";
import { SelectMenu } from "@/components/SelectMenu";
import { keyOptions } from "@/constants/keyOptions";
import { useNamedKey } from "@/lib/zustand/useKey";
import { useNamedPitchCorrection } from "@/lib/zustand/usePitchCorrection";
import { KeyOption } from "@/types/defs/keyOption";
import { Undoable } from "@/types/defs/pitchCorrection/undoable";

export function PitchSelectMenu({
  namespace,
  noKeyIsAnOption,
  className,
}: {
  namespace: string;
  noKeyIsAnOption: boolean;
  className?: string;
}) {
  const usePitchCorrection = useNamedPitchCorrection((state) =>
    state.getNamedStore(namespace)
  );
  const useKey = useNamedKey((state) => state.getNamedStore(namespace));
  const key = useKey((state) => state.key);
  const myKeyOptions =
    noKeyIsAnOption || key === "No Key" ?
      keyOptions()
    : keyOptions().filter((k) => k !== "No Key");
  // todo: clean up code dup with pitch knob
  const pitchesDirty = usePitchCorrection((state) => state.pitchesDirty);
  const setPitches = usePitchCorrection((state) => state.setPitches);
  const previousPitchLevel = usePitchCorrection(
    (state) => state.previousPitchLevel
  );
  const previousVibratoLevel = usePitchCorrection(
    (state) => state.previousVibratoLevel
  );
  const previousPitchPitches = usePitchCorrection(
    (state) => state.previousPitchPitches
  );
  const setKey = useKey((state) => state.setKey);
  const originalPitches = usePitchCorrection((state) => state.originalPitches);
  const pitches = usePitchCorrection((state) => state.pitches);
  const circles = usePitchCorrection((state) => state.circles);
  const addToUndoStack_ = usePitchCorrection((state) => state.addToUndoStack);
  const setRedoStack = usePitchCorrection((state) => state.setRedoStack);
  const addToUndoStack = (a: Undoable) => {
    addToUndoStack_(a);
    setRedoStack([]);
  };
  const updatePitchesAndUndoStack = (k: KeyOption) => {
    const pitchDiffsAre =
      originalPitches.length > 0 && circles.length > 0 ?
        pitchDiffsFromSemitoneData(originalPitches, keyStore([])[k], circles)
      : [];
    const pitchDiffsWere =
      originalPitches.length > 0 && circles.length > 0 ?
        pitchDiffsFromSemitoneData(originalPitches, keyStore([])[key], circles)
      : [];
    const newPitches = handleKnobPitchChangeInternal(
      previousPitchLevel,
      previousPitchLevel,
      previousPitchPitches ?? pitches,
      pitchDiffsWere,
      pitchDiffsAre,
      pitchesDirty
    );
    addToUndoStack({
      time: new Date(),
      source: "edit",
      value: {
        pitches: pitches.slice(),
        vibratoLevel: previousVibratoLevel,
        pitchLevel: previousPitchLevel,
        // old key
        key,
      },
    });
    setPitches(newPitches);
  };
  return (
    <SelectMenu
      items={myKeyOptions}
      selectedIndex={myKeyOptions.indexOf(key)}
      setSelectedIndex={(i) => {
        const newKey = myKeyOptions[i];
        if (pitches.length > 0) {
          updatePitchesAndUndoStack(newKey);
        }
        setKey(newKey);
      }}
      disabled={false}
      highlight={key === "No Key" && !noKeyIsAnOption}
      className={twMerge("", className)}
    />
  );
}
